import BottomDrawer from "chatComponents/components/bottomDrawer/BottomDrawer";

const ButtonChat = () => {
  return <BottomDrawer />;
};

export default ButtonChat;
